import { render, staticRenderFns } from "./AboutMeCard.vue?vue&type=template&id=07502c0b&scoped=true&"
import script from "./AboutMeCard.vue?vue&type=script&lang=js&"
export * from "./AboutMeCard.vue?vue&type=script&lang=js&"
import style0 from "./AboutMeCard.vue?vue&type=style&index=0&id=07502c0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07502c0b",
  null
  
)

export default component.exports